<app-modal title="Rename {{ switchboard_object?.object_type }}" size="small" (save)="rename()" #rename_modal>
    <input type="text" class="form-control" [(ngModel)]="new_name">
</app-modal>